import React from "react";
import { Icon } from "@iconify/react";
import { Typography } from "../../../Components/Typography";
import GeminiAutocomplete from "../../../Components/GeminiAutocomplete";

export function getEducationInfoFields() {
  const currentYear = new Date().getFullYear();
  const graduationYears = Array.from({ length: 8 }, (_, i) => currentYear - 2 + i);
  return [
    {
      name: "section_education",
      type: "custom",
      component: (
        <div className="flex flex-col gap-1 py-4 border-t border-b border-slate-200 mt-4 text-left">
          <Typography as="h2" className="text-lg font-bold text-primary-900">
            Your Intellectual Origin
          </Typography>
          <Typography as="p" className="text-sm text-tertiary-600">
            Define the academic rigors and specializations
          </Typography>
        </div>
      ),
    },
    {
      name: "collage",
      label: "Institution Name (College/University)",
      type: "custom",
      required: true,
      render: (value, formData, handleInputChange, error) => (
        <div className="flex flex-col gap-1">
          <GeminiAutocomplete
            label="Institution Name (College/University)"
            value={formData.collage || ""}
            onChange={(val) => handleInputChange("collage", val)}
            placeholder="Enter the name of your institution"
            className={`w-full rounded-lg border ${
              error ? "border-red-400" : "border-slate-200"
            } bg-white px-4 py-2.5 text-sm text-slate-900 shadow-sm focus:border-brand-blue focus:outline-none focus:ring-2 focus:ring-brand-blue`}
            error={!!error}
          />
        </div>
      ),
    },
    {
      name: "year",
      label: "Year of Graduation",
      type: "custom",
      required: true,
      render: (value, formData, handleInputChange, error) => (
        <div className="relative">
          <select
            value={formData.year || ""}
            onChange={(e) => handleInputChange("year", e.target.value)}
            className={`w-full rounded-lg border ${
              error ? "border-red-400" : "border-slate-200"
            } bg-white px-4 pr-10 py-2.5 text-sm text-slate-900 shadow-sm focus:border-brand-blue focus:outline-none focus:ring-2 focus:ring-brand-blue appearance-none`}
          >
            <option value="">Select your year of graduation</option>
            {graduationYears.map((y) => (
              <option key={y} value={y}>
                {y}
              </option>
            ))}
          </select>
          <Icon
            icon="lucide:chevron-down"
            className="absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400 pointer-events-none"
          />
        </div>
      ),
    },
    {
      name: "primary_stream",
      label: "Primary Stream",
      type: "custom",
      required: true,
      render: (value, formData, handleInputChange, error) => (
        <div className="flex flex-col gap-1">
          <GeminiAutocomplete
            label="Primary Stream"
            value={formData.primary_stream || ""}
            onChange={(val) => handleInputChange("primary_stream", val)}
            placeholder="Select your primary stream"
            className={`w-full rounded-lg border ${
              error ? "border-red-400" : "border-slate-200"
            } bg-white px-4 py-2.5 text-sm text-slate-900 shadow-sm focus:border-brand-blue focus:outline-none focus:ring-2 focus:ring-brand-blue`}
            error={!!error}
          />
        </div>
      ),
    },
    {
      name: "specialization",
      label: "Specialization",
      type: "custom",
      required: false,
      render: (value, formData, handleInputChange, error) => (
        <div className="flex flex-col gap-1">
          <GeminiAutocomplete
            label="Specialization"
            value={formData.specialization || ""}
            onChange={(val) => handleInputChange("specialization", val)}
            placeholder="Enter your specialization here"
            className={`w-full rounded-lg border ${
              error ? "border-red-400" : "border-slate-200"
            } bg-white px-4 py-2.5 text-sm text-slate-900 shadow-sm focus:border-brand-blue focus:outline-none focus:ring-2 focus:ring-brand-blue`}
            error={!!error}
          />
        </div>
      ),
    },
  ];
}
